import { NgModule } from "@angular/core";
import { Routes, RouterModule } from "@angular/router";

import { FullComponent } from "./layouts/full/full.component";
import { BlankComponent } from "./layouts/blank/blank.component";
import { AuthGuard } from './guards/auth.guard';

export const Approutes: Routes = [
  { path: 'dashboard',
  component: FullComponent,
  loadChildren: () => import('./dashboards/dashboard.module').then(m => m.DashboardModule) },

  {
    path: "",
    component: FullComponent,
    canActivate: [AuthGuard],
    children: [
      { path: "", redirectTo: "modulo/lavanderia/guia-de-recepcion", pathMatch: "full" },

      //MODULOS DE PLANILLA

      {
        path: "planilla",
        loadChildren: () =>
          import("./modulos/planilla/planilla.module").then(
            (m) => m.PlanillaModule),
      },
      // { path: 'lavanderia', loadChildren: () => import('./lavanderia/lavanderia.module').then(m => m.LavanderiaModule), }, ArchivosModule

      {
        path: "modulo/lavanderia",
        loadChildren: () =>
          import("./modulos/lavanderia/lavanderia.module").then(
            (m) => m.LavanderiaModule),
      },
      {
        path: "modulo/archivos",
        loadChildren: () =>
          import("./modulos/archivos/archivos.module").then(
            (m) => m.ArchivosModule),
      },
      
    ],
  },
  {
    path: "",
    component: BlankComponent,
    children: [
      {
        path: "",
        loadChildren: () =>
          import("./authentication/authentication.module").then(
            (m) => m.AuthenticationModule
          ),
      },
    ],
  },
  {
    path: "**",
    redirectTo: "/404",
  },
];
